import { Trash2 } from 'lucide-react';
import { useState } from 'react';

import type { WorkshopDetailHeaderProps } from './workshopDetailHeader.types';

/** Discard (inline-confirm) + Publish — draft, not editing. */
export function WorkshopHeaderDraftActions({
  discarding,
  publishing,
  onPublish,
  onDiscard,
}: Pick<WorkshopDetailHeaderProps, 'discarding' | 'publishing' | 'onPublish' | 'onDiscard'>) {
  const [confirming, setConfirming] = useState(false);

  if (confirming) {
    return (
      <>
        <span style={{ fontSize: 12.5, color: 'var(--nb-ink)', fontWeight: 600 }}>
          Discard this draft?
        </span>
        <button
          type="button"
          className="nb-btn"
          onClick={onDiscard}
          disabled={discarding}
          style={{ background: '#c0392b', color: '#fff', borderColor: '#c0392b' }}
        >
          <Trash2 size={13} />
          {discarding ? 'Discarding…' : 'Yes, discard'}
        </button>
        <button
          type="button"
          className="nb-btn nb-btn-ghost"
          onClick={() => setConfirming(false)}
          disabled={discarding}
        >
          Keep draft
        </button>
      </>
    );
  }

  return (
    <>
      <button
        type="button"
        className="nb-btn nb-btn-ghost"
        onClick={() => setConfirming(true)}
        disabled={discarding}
      >
        <Trash2 size={13} />
        Discard
      </button>
      <button
        type="button"
        className="nb-btn nb-btn-primary"
        onClick={onPublish}
        disabled={publishing}
      >
        {publishing ? 'Publishing…' : 'Publish'}
      </button>
    </>
  );
}
